import Utils from 'services/utils';

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * FeedbackApi class.
 */
export default class FeedbackApi {
    /** @ngInject */
    constructor($http) {
        this.$http = $http;
        this.feedbackUrl = Utils.buildApiUrl('feedback.url');
    }

    create(feedback) {
        return this.$http.post(this.feedbackUrl, { ...feedback }).then(responseDataExtractor);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/feedback/feedback.service.js